import { Pipe, PipeTransform } from '@angular/core';
import { FileMetadata } from 'src/app/models/collection.interface';

type ProcessingStage = FileMetadata['processing_stage'];

@Pipe({
  name: 'processingStage',
  pure: true,
  standalone: true
})
export class ProcessingStagePipe implements PipeTransform {
  transform(value: ProcessingStage | string): string {
    if (!value) {
      return 'N/A';
    }

    const result = value.replace(/_/g, ' ');

    if (result === '') {
      return 'Pending';
    }

    return result.charAt(0).toUpperCase() + result.slice(1);
  }
}
